import type { IssueTypes } from '@risksmart-app/trpc/src/services/service.types';
import type {
  GetIssueCountQuery,
  Issue_Bool_Exp,
} from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetIssueCountDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type IssueCountArgs = {
  // The issue Type to count ('issue' for the main badge, or a subtype).
  issueType: IssueTypes;
  // Resolved entity-filter selection — drives the tRPC path. Only the main
  // 'issue' badge passes this; the subtype badges omit it and stay global.
  entityIds?: string[];
  // The equivalent Hasura bool_exp (incl. Type) — drives the GraphQL fallback
  // so the flag-gated twin counts identically.
  where?: Issue_Bool_Exp;
};

export const useGetIssueCount = createQueryHook<
  IssueCountArgs,
  number,
  GetIssueCountQuery
>({
  trpcQueryOptions: (trpc, queryArgs) =>
    trpc.frontend.issue.issueCount.queryOptions({
      issueType: queryArgs?.issueType ?? 'issue',
      entityIds: queryArgs?.entityIds,
    }),
  // Pass the count straight through (not `data ?? 0`): the factory surfaces
  // undefined while loading, so a genuine 0 must stay 0.
  mapTrpcDataToGraphQL: (data) => ({
    issue_aggregate: {
      aggregate: {
        count: data,
      },
    },
  }),
  graphqlDocument: GetIssueCountDocument,
  graphqlVariables: (queryArgs) => ({ where: queryArgs?.where }),
});
